const headerDrawerMenu = document.querySelector(".la-menu-drawer-container");
const slidDrawerMenu = document.querySelector(".la-menu-drawer");
const bodyDrawerMenu = document.body;
const htmlDrawerMenu = document.documentElement;
const buttonClose = document.querySelector(".la-close-button-drawer-menu");
const buttonOpen = document.querySelector(".icon-hamburger-la");
const inputValue = document.querySelectorAll(".la-search-menu-drawer");
const resultsInpute = document.querySelector("#predictive-search-results-la");
const navContiner = document.querySelector(".la-menu-drawer__navigation");
const clickSearchButton = document.querySelector(".la-search-header-button");
const activeSearch = document.querySelector(".la-menu_desktop-search_continer");
const resultsDesktopInput = document.querySelector("#desktop_menu_search-la");
const desktopMenuItems = document.querySelectorAll(
  ".header-desktop-nav-area-la .mega-menu__item-la"
);
let lastScrollTop = 0;
let drawerScrollY = 0;
let previousDrawerBodyStyles = null;
let drawerLockRefreshTimer = null;
let drawerTouchStartY = 0;
let desktopSearchFocusTimer = null;
const header = document.getElementById("main-header-la");
const menuItems = document.querySelectorAll(
  ".collection_header_animet_item-la"
);
const announcementLa = document.querySelector(".announcement_bar-la");

function getDrawerViewportHeight() {
  return Math.round(window.visualViewport?.height || window.innerHeight);
}

function closeMenuDetails() {
  document
    .querySelectorAll(".la-menu-drawer .details-la[open]")
    .forEach((details) => details.removeAttribute("open"));
  navContiner && navContiner.classList.remove("navHeight");
}

function resetDrawerSearch() {
  inputeValue();
  if (resultsInpute) {
    resultsInpute.style.display = "none";
    resultsInpute.innerHTML = "";
  }
}

function closeDesktopSearch() {
  if (!activeSearch?.classList.contains("active_serach_button-la")) return;

  activeSearch.classList.remove("active_serach_button-la");
  window.clearTimeout(desktopSearchFocusTimer);
  desktopSearchFocusTimer = null;
  resultsDesktopInput && (resultsDesktopInput.innerHTML = "");
  inputeValue();

  if (resultsInpute) {
    resultsInpute.style.display = "none";
    resultsInpute.innerHTML = "";
  }

  if (activeSearch.contains(document.activeElement)) {
    document.activeElement.blur();
  }
}

function lockDrawerPageScroll() {
  if (bodyDrawerMenu.dataset.drawerScrollLocked === "true") {
    refreshDrawerPageScrollLock();
    return;
  }

  drawerScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
  previousDrawerBodyStyles = {
    position: bodyDrawerMenu.style.position,
    top: bodyDrawerMenu.style.top,
    left: bodyDrawerMenu.style.left,
    right: bodyDrawerMenu.style.right,
    width: bodyDrawerMenu.style.width,
    height: bodyDrawerMenu.style.height,
    maxHeight: bodyDrawerMenu.style.maxHeight,
    overflow: bodyDrawerMenu.style.overflow,
    touchAction: bodyDrawerMenu.style.touchAction,
    viewportHeight: htmlDrawerMenu.style.getPropertyValue("--drawer-viewport-height"),
  };

  htmlDrawerMenu.style.setProperty("--drawer-viewport-height", `${getDrawerViewportHeight()}px`);
  bodyDrawerMenu.dataset.drawerScrollLocked = "true";
  bodyDrawerMenu.dataset.drawerScrollY = String(drawerScrollY);
  htmlDrawerMenu.classList.add("header-drawer-body-la");
  bodyDrawerMenu.classList.add("header-drawer-body-la");
  bodyDrawerMenu.style.overflow = "hidden";
  bodyDrawerMenu.style.touchAction = "none";
}

function refreshDrawerPageScrollLock() {
  if (bodyDrawerMenu.dataset.drawerScrollLocked !== "true") return;

  htmlDrawerMenu.style.setProperty("--drawer-viewport-height", `${getDrawerViewportHeight()}px`);
  htmlDrawerMenu.classList.add("header-drawer-body-la");
  bodyDrawerMenu.classList.add("header-drawer-body-la");
  bodyDrawerMenu.style.overflow = "hidden";
  bodyDrawerMenu.style.touchAction = "none";
}

function scheduleDrawerScrollLockRefresh() {
  if (!slidDrawerMenu || !slidDrawerMenu.classList.contains("active-header-drawer-la")) return;

  refreshDrawerPageScrollLock();
  window.requestAnimationFrame(refreshDrawerPageScrollLock);
  setTimeout(refreshDrawerPageScrollLock, 250);
  setTimeout(refreshDrawerPageScrollLock, 650);
}

function startDrawerScrollLockRefreshLoop() {
  if (drawerLockRefreshTimer) return;

  scheduleDrawerScrollLockRefresh();
  drawerLockRefreshTimer = window.setInterval(refreshDrawerPageScrollLock, 120);
}

function stopDrawerScrollLockRefreshLoop() {
  if (!drawerLockRefreshTimer) return;

  window.clearInterval(drawerLockRefreshTimer);
  drawerLockRefreshTimer = null;
}

function getDrawerScrollableTarget(target) {
  if (!target || typeof target.closest !== "function") return null;

  return target.closest(
    "#predictive-search-results-la, .la-menu-drawer__navigation, .la-drawer-menu-link_wrapper, .la-drawer-menu-childlink_wrapper"
  );
}

function handleDrawerTouchStart(event) {
  if (bodyDrawerMenu.dataset.drawerScrollLocked !== "true") return;

  drawerTouchStartY = event.touches?.[0]?.clientY || 0;
}

function handleDrawerTouchMove(event) {
  if (
    bodyDrawerMenu.dataset.drawerScrollLocked !== "true" ||
    !slidDrawerMenu ||
    !slidDrawerMenu.classList.contains("active-header-drawer-la")
  ) {
    return;
  }

  const scrollableTarget = getDrawerScrollableTarget(event.target);
  if (!scrollableTarget) {
    event.preventDefault();
    return;
  }

  const currentY = event.touches?.[0]?.clientY || drawerTouchStartY;
  const isMovingDown = currentY > drawerTouchStartY;
  const isAtTop = scrollableTarget.scrollTop <= 0;
  const isAtBottom =
    scrollableTarget.scrollTop + scrollableTarget.clientHeight >= scrollableTarget.scrollHeight - 1;

  if ((isAtTop && isMovingDown) || (isAtBottom && !isMovingDown)) {
    event.preventDefault();
  }
}

function unlockDrawerPageScroll() {
  const restoreY = parseInt(bodyDrawerMenu.dataset.drawerScrollY || String(drawerScrollY), 10);

  stopDrawerScrollLockRefreshLoop();
  htmlDrawerMenu.classList.remove("header-drawer-body-la");
  bodyDrawerMenu.classList.remove("header-drawer-body-la");
  bodyDrawerMenu.style.position = previousDrawerBodyStyles?.position || "";
  bodyDrawerMenu.style.top = previousDrawerBodyStyles?.top || "";
  bodyDrawerMenu.style.left = previousDrawerBodyStyles?.left || "";
  bodyDrawerMenu.style.right = previousDrawerBodyStyles?.right || "";
  bodyDrawerMenu.style.width = previousDrawerBodyStyles?.width || "";
  bodyDrawerMenu.style.height = previousDrawerBodyStyles?.height || "";
  bodyDrawerMenu.style.maxHeight = previousDrawerBodyStyles?.maxHeight || "";
  bodyDrawerMenu.style.overflow = previousDrawerBodyStyles?.overflow || "";
  bodyDrawerMenu.style.touchAction = previousDrawerBodyStyles?.touchAction || "";
  if (previousDrawerBodyStyles?.viewportHeight) {
    htmlDrawerMenu.style.setProperty("--drawer-viewport-height", previousDrawerBodyStyles.viewportHeight);
  } else {
    htmlDrawerMenu.style.removeProperty("--drawer-viewport-height");
  }
  delete bodyDrawerMenu.dataset.drawerScrollLocked;
  delete bodyDrawerMenu.dataset.drawerScrollY;
  previousDrawerBodyStyles = null;
  window.scrollTo(0, restoreY);
}

function closeMobileDrawer() {
  slidDrawerMenu.classList.remove("active-header-drawer-la");
  unlockDrawerPageScroll();
  headerDrawerMenu.classList.remove("active-header-drawer_menu-la");
  closeMenuDetails();
  resetDrawerSearch();
}

menuItems.forEach((menuItem) => {
  const itemsContainer = menuItem.querySelector(
    ".desktop_menu_collection_continer-la"
  );
  if (!itemsContainer) return;

  const items = itemsContainer.querySelectorAll(
    ".desktop_item_in_collection_menu"
  );

  menuItem.addEventListener("mouseenter", () => {
    menuItem.classList.add("collection_header_mouseenter-la")
    items.forEach((item, index) => {
      setTimeout(() => {
        item.classList.add("visible");
      }, index * 50);
    });
  });

  menuItem.addEventListener("mouseleave", () => {
    items.forEach((item) => item.classList.remove("visible"));
    menuItem.classList.remove("collection_header_mouseenter-la")
    
  });
});

window.addEventListener("scroll", () => {
  if (
    bodyDrawerMenu.dataset.drawerScrollLocked === "true" &&
    slidDrawerMenu &&
    slidDrawerMenu.classList.contains("active-header-drawer-la")
  ) {
    const lockedScrollY = parseInt(bodyDrawerMenu.dataset.drawerScrollY || String(drawerScrollY), 10);
    refreshDrawerPageScrollLock();
    if ((window.pageYOffset || document.documentElement.scrollTop || 0) !== lockedScrollY) {
      window.scrollTo(0, lockedScrollY);
    }
    return;
  }

  const currentScrollTop =
    window.pageYOffset || document.documentElement.scrollTop;

  if (currentScrollTop === 0) {
    header.classList.add("header-not-fixed");
    announcementLa.classList.remove("announcementNew");
  } else {
    header.classList.remove("header-not-fixed");
    announcementLa.classList.add("announcementNew");
  }

  if (currentScrollTop > lastScrollTop) {
    header.classList.add("header--hidden");
    announcementLa.classList.add("announcementRemove");
    header.classList.remove("bottomScroll");
  } else {
    header.classList.remove("header--hidden");
    header.classList.add("bottomScroll");
    announcementLa.classList.remove("announcementRemove");
  }

  lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
});

document
  .querySelectorAll(".la-menu-drawer .details-la > .summary-la")
  .forEach((summary) => {
    const details = summary.closest(".details-la");

    summary &&
      summary.addEventListener("click", () => {
        details.setAttribute("open", true);
        navContiner.classList.add("navHeight");
      });

    const closeButton = details.querySelector(".la-close-menu-drawer");
    if (closeButton) {
      closeButton.addEventListener("click", () => {
        details.removeAttribute("open");
        navContiner.classList.remove("navHeight");
      });
    }

    if (summary.closest("header-drawer, drawer")) return;

  });
function inputeValue() {
  inputValue.forEach((el) => {
    el.value = "";
  });
}
headerDrawerMenu &&
  headerDrawerMenu.addEventListener("click", (event) => {
    if (event.target === event.currentTarget) {
      closeMobileDrawer();
    }
  });

buttonOpen &&
  buttonOpen.addEventListener("click", () => {
    slidDrawerMenu.classList.add("active-header-drawer-la");
    lockDrawerPageScroll();
    headerDrawerMenu.classList.add("active-header-drawer_menu-la");
    scheduleDrawerScrollLockRefresh();
  });

buttonClose &&
  buttonClose.addEventListener("click", () => {
    closeMobileDrawer();
  });
document.querySelectorAll(".la-close-subdrawer-menu").forEach((button) => {
  button.addEventListener("click", closeMobileDrawer);
});



document.querySelectorAll(".la-mobile-subgroup-open-la").forEach((button) => {
  const details = button.closest(".details-la");
  const closeButton = details && details.querySelector(".la-drawer-menu-childlink .la-close-menu-drawer");

  button.addEventListener("click", () => {
    if (!details) return;

    Array.from(details.parentElement.children).forEach((sibling) => {
      if (sibling !== details && sibling.matches(".details-la[open]")) {
        sibling.removeAttribute("open");
        const siblingButton = sibling.querySelector(".la-mobile-subgroup-open-la");
        siblingButton && siblingButton.setAttribute("aria-expanded", "false");
      }
    });

    details.setAttribute("open", true);
    button.setAttribute("aria-expanded", "true");
    navContiner.classList.add("navHeight");
  });

  closeButton &&
    closeButton.addEventListener("click", () => {
      details.removeAttribute("open");
      button.setAttribute("aria-expanded", "false");
      navContiner.classList.remove("navHeight");
    });
});

inputValue.forEach((input) => {
  input.addEventListener("focus", startDrawerScrollLockRefreshLoop);
  input.addEventListener("input", scheduleDrawerScrollLockRefresh);
  input.addEventListener("keydown", scheduleDrawerScrollLockRefresh);
  input.addEventListener("keyup", scheduleDrawerScrollLockRefresh);
  input.addEventListener("blur", () => {
    scheduleDrawerScrollLockRefresh();
    setTimeout(stopDrawerScrollLockRefreshLoop, 700);
  });
});

document.addEventListener("touchstart", handleDrawerTouchStart, { passive: true });
document.addEventListener("touchmove", handleDrawerTouchMove, { passive: false });

if (window.visualViewport) {
  window.visualViewport.addEventListener("resize", scheduleDrawerScrollLockRefresh);
  window.visualViewport.addEventListener("scroll", scheduleDrawerScrollLockRefresh);
}

desktopMenuItems.forEach((menuItem) => {
  menuItem.addEventListener("mouseenter", closeDesktopSearch);
});

clickSearchButton &&
  clickSearchButton.addEventListener("click", () => {
    const isOpening = activeSearch.classList.toggle("active_serach_button-la");
    window.clearTimeout(desktopSearchFocusTimer);
    resultsDesktopInput && (resultsDesktopInput.innerHTML = "");
    inputeValue();
    if (resultsInpute) resultsInpute.style.display = "none";

    if (!isOpening) return;

    desktopSearchFocusTimer = window.setTimeout(() => {
      if (!activeSearch.classList.contains("active_serach_button-la")) return;

      activeSearch.querySelector("input")?.focus();
      scheduleDrawerScrollLockRefresh();
      desktopSearchFocusTimer = null;
    }, 600);
  });
